var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "emd-menu__section menu-section",
      class: {
        _active: _vm.active,
        _open: _vm.opened,
      },
      attrs: {
        "data-onboarding":
          _vm.item.routeName === "settings" ? _vm.item.routeName : null,
      },
    },
    [
      _c("a", { staticClass: "menu-link", on: { click: _vm.setOpenSection } }, [
        _c(
          "span",
          {
            staticClass: "emd-menu__label menu-item",
            attrs: { "data-testid": "dropdown-menu" },
          },
          [_vm._v(_vm._s(_vm.$t(_vm.item.label)))]
        ),
        _vm.item.new
          ? _c(
              "span",
              {
                staticClass:
                  "emd-tag _color_info eu-ml_2 eu-display_none eu-display_inline_md",
              },
              [_vm._v(_vm._s(_vm.$t("sidemenu.new")))]
            )
          : _vm._e(),
        _vm.item.items
          ? _c("div", { staticClass: "emd-menu__arrow menu-icon" }, [
              _c("i", { staticClass: "uil uil-angle-right" }),
            ])
          : _vm._e(),
        _vm.item.beta
          ? _c(
              "span",
              {
                staticClass:
                  "emd-tag _color_info eu-ml_2 eu-display_none eu-display_inline_md",
              },
              [_vm._v(_vm._s(_vm.$t("sidemenu.beta")))]
            )
          : _vm._e(),
      ]),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }